import { env } from './env';

/**
 * Which parts of the platform this client actually bought.
 *
 * Derived from configuration, not hard-coded: a client with no booking service
 * has no `VITE_BOOKING_API_URL`, so booking is simply absent — from the sidebar,
 * from the command palette and from the marketing copy on the login screen.
 * The old portal showed every module to everyone and let the pages fail at
 * request time against an empty base URL.
 */
export const features = {
  booking: env.bookingApiUrl.length > 0,
  images: env.imagesUrl.length > 0,
  payments: env.paymentsKey.length > 0,
  maps: env.geoApiKey.length > 0,
  /**
   * Unlike the others this cannot be inferred from a URL or a key: the
   * endpoints exist for every client, but only some invite the public to apply
   * for an account, so it is stated outright with `VITE_HAS_ACCOUNT_REQUESTS`.
   */
  accountRequests: env.hasAccountRequests,
  /**
   * The same case: every client has the delivery endpoints, one of them works
   * with third-party delivery providers. Stated with `VITE_HAS_3PL_DELIVERIES`;
   * the store's own `allowDelivery` switch still has to be on as well.
   */
  thirdPartyDelivery: env.has3plDeliveries,
} as const;

export type Feature = keyof typeof features;

export function hasFeature(feature: Feature | undefined): boolean {
  return feature === undefined || features[feature];
}
